// src/hooks/cities/useDeleteCity.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteCity } from "../../api/apiCities";
import parseError from "../../utils/parseError";

const useDeleteCity = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteCityMutate, isPending } = useMutation({
        mutationFn: deleteCity,
        onSuccess: (res) => {
            const message = res?.message || "City deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["cities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete city");
        },
    });

    return { deleteCityMutate, isPending };
};

export default useDeleteCity;